module.exports = __webpack_public_path__ + "static/commision-img3-4cd72569f822eb627c2be23a75d9f3ff.jpg";